<div class="page-section series-form-page">
	<div class="app-l-page__navigation">
		<div class="app-l-page__previous" [routerLink]="['/admin/organization-listing']">
			<button class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20">
				<svg-icon icon="arrow-left" class="w-100 h-100"></svg-icon>
			</button>
		</div>
		<div class="app-l-page__breadcrumbs">
			<ul class="breadcrumbs-list">
				<li class="breadcrumbs-list-item">
					<a [routerLink]="['/admin/organization-listing']">Organizations</a>
				</li>
				<li class="breadcrumbs-list-item app-l-current-page">
					Clone Organization
				</li>
			</ul>
		</div>
	</div>
	<div class="page-section-content">
		<page-loader *ngIf="!isLoaded"></page-loader>
		<div class="form-wrapper-80" *ngIf="isLoaded">
			<div class="app-c-form-group">
				<label class="app-c-form--label" for="sourceOrg">Source Organization</label>
				<select
					class="app-c-form-control"
					[(ngModel)]="sourceOrgID"
					id="sourceOrg"
					required>
					<option [value]="null">Select an organization...</option>
					<option *ngFor="let org of organizations" [value]="org.id">
						{{ org.name }}
					</option>
				</select>
				<div class="error-message"
					*ngIf="submitButtonPressed && !sourceOrgID">
					Please select a source organization.
				</div>
			</div>

			<div class="fixed-footer">
				<div class="validation-banner" *ngIf="errors">
					{{ errors }}
				</div>
				<button class="app-c-btn app-c-btn--primary app-c-btn--curve" (click)="doSave()">
					Clone
				</button>
			</div>
		</div>
	</div>
</div>
